import React from "react";
import { withTranslation } from "react-i18next";
import Moment from "react-moment";
import Avatar from "components/Avatar";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";
import { Tablet, Desktop, Mobile } from "utils/responsive";
import { Dropdown } from "react-bootstrap";
import { FiMoreHorizontal } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import EmployeeListItemHeader from "components/Employees/EmployeeListItemHeader";
import AbsenceListItemPeriod from "components/Absences/AbsenceListItemPeriod";
import { wfStatus } from "services/workflowsService";

const ManagedPreferencesList = (props) => {
	// console.log(props);
	// console.log(props.managed_preferences);

	if (
		props.managed_preferences == undefined ||
		props.managed_preferences.length === 0
	)
		return getEmptyRow(props.t);

	if (props.is_list_view) {
		return (
			<>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-preferences table-mobile">
							<tbody>{getTableRowsMobile(props, props.t)}</tbody>
						</table>
					</div>
				</Mobile>
				<Tablet>
					<div className="table-tablet-container">
						<table className="table table-preferences table-tablet">
							<tbody>{getTableRowsTablet(props, props.t)}</tbody>
						</table>
					</div>
				</Tablet>
				<Desktop>
					<table className="table table-preferences table-desktop table-zebra">
						<thead>
							<tr>
								<th>{props.t("preferences.columns.employee")}</th>
								<th>{props.t("preferences.columns.shift")}</th>
								<th>{props.t("preferences.columns.period")}</th>
								<th>{props.t("preferences.columns.status")}</th>
								<th>{props.t("preferences.columns.requested")}</th>
								<th>{props.t("preferences.columns.resolved")}</th>
								<th>{props.t("preferences.columns.managed")}</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>{getTableRows(props, props.t)}</tbody>
					</table>
				</Desktop>
			</>
		);
	}

	return <div className="row grid-preferences">{getGridRows(props, props.t)}</div>;
};

const getEmptyRow = (t) => {
	return <p className="no-results">{t("preferences.noResults")}</p>;
};

const getTableRows = (props, t) =>
	props.managed_preferences.map((preference) => (
		<tr key={preference.id} className="row-ausencia">
			<td className="td-name">
				<div className="td-name-content">
					<EmployeeLink employee={preference.requester}>
						<Avatar
							userId={preference.requester.id}
							className="avatar-sm"
							alt={preference.requester.name}
						/>
					</EmployeeLink>
					<div className="employee-info">
						<EmployeeLink
							className="employee-name"
							employee={preference.requester}
						>
							{preference.requester.name} {preference.requester.surname}
						</EmployeeLink>
					</div>
				</div>
			</td>
			<td>
				<span
					className="card-shift"
					style={{
						backgroundColor:
							preference.shift.background_color &&
							preference.shift.background_color,
						borderColor:
							preference.shift.border_color && preference.shift.border_color,
					}}
				>
					{preference.shift.name}
				</span>
			</td>
			<td>
				<AbsenceListItemPeriod absence={preference} />
			</td>
			<td>
				<span className={`estado ${preference.status}`}>
					{preference.status}
				</span>
			</td>
			<td>
				<Moment className="tag-dia" format="D/MM/YYYY">
					{preference.requested}
				</Moment>
			</td>
			<td>
				<Moment className="tag-dia" format="D/MM/YYYY">
					{preference.answered}
				</Moment>
			</td>
			<td className="td-name">
				{preference.answerer && (
					<div className="td-name-content">
						<EmployeeLink employee={preference.answerer}>
							<Avatar
								userId={preference.answerer.id}
								className="avatar-xxs"
								alt={preference.answerer.name}
							/>
						</EmployeeLink>
						<div className="employee-info">
							<EmployeeLink
								className="employee-name"
								employee={preference.answerer}
							>
								{preference.answerer.name} {preference.answerer.surname}
							</EmployeeLink>
						</div>
					</div>
				)}
			</td>
			<td>
				{preference.attachments && preference.attachments.length > 0 && (
					<MdAttachFile
						title={t("preferences.hasAttachments")}
						className="preference-attachment"
					/>
				)}
			</td>
			<td className="td-actions">{getActions(props, preference, t)}</td>
		</tr>
	));

const getTableRowsTablet = (props, t) =>
	props.managed_preferences.map((preference) => (
		<tr key={preference.id} className="row-ausencia">
			<td className="td-name">
				<div className="td-name-content">
					<EmployeeLink employee={preference.requester}>
						<Avatar
							userId={preference.requester.id}
							className="avatar-sm"
							alt={preference.requester.name}
						/>
					</EmployeeLink>
					<div className="employee-info">
						<EmployeeLink
							className="employee-name"
							employee={preference.requester}
						>
							{preference.requester.name} {preference.requester.surname}
						</EmployeeLink>
					</div>
				</div>
			</td>
			<td>
				<span
					className="card-shift"
					style={{
						backgroundColor:
							preference.shift.background_color &&
							preference.shift.background_color,
						borderColor:
							preference.shift.border_color && preference.shift.border_color,
					}}
				>
					{preference.shift.name}
				</span>
			</td>
			<td>
				<span className={`estado ${preference.status}`}>
					{preference.status}
				</span>
			</td>
			<td>
				<AbsenceListItemPeriod absence={preference} />
			</td>
			<td>
				{preference.attachments && preference.attachments.length > 0 && (
					<MdAttachFile
						title={t("preferences.hasAttachments")}
						className="preference-attachment"
					/>
				)}
			</td>
			<td className="td-actions">{getActions(props, preference, t)}</td>
		</tr>
	));

const getTableRowsMobile = (props, t) =>
	props.managed_preferences.map((preference) => (
		<tr key={preference.id} className="row-ausencia">
			<td className="td-name">
				<div className="td-name-content">
					<EmployeeLink employee={preference.requester}>
						<Avatar
							userId={preference.requester.id}
							className="avatar-sm"
							alt={preference.requester.name}
						/>
					</EmployeeLink>
					<div className="employee-info">
						<EmployeeLink
							className="employee-name"
							employee={preference.requester}
						>
							{preference.requester.name} {preference.requester.surname}
						</EmployeeLink>
					</div>
				</div>

				<AbsenceListItemPeriod absence={preference} />
			</td>
			<td>
				<span
					className="card-shift"
					style={{
						backgroundColor:
							preference.shift.background_color &&
							preference.shift.background_color,
						borderColor:
							preference.shift.border_color && preference.shift.border_color,
					}}
				>
					{preference.shift.name}
				</span>

				<span className={`estado ${preference.status}`}>
					{preference.status}
				</span>
			</td>

			<td className="td-actions">{getActions(props, preference, t)}</td>
		</tr>
	));

const getGridRows = (props, t) =>
	props.managed_preferences.map((preference) => (
		<div className="col-sm-6 col-lg-4 col-xl-3" key={preference.id}>
			<article className="card card-ausencia" key={preference.id}>
				<EmployeeListItemHeader employee={preference.requester} />

				<div className="card-content">
					{/* <span className="preference-comments">{preference.comments}</span> */}

					<span
						className="card-shift"
						style={{
							backgroundColor:
								preference.shift.background_color &&
								preference.shift.background_color,
							borderColor:
								preference.shift.border_color && preference.shift.border_color,
						}}
					>
						{preference.shift.name}
					</span>

					<AbsenceListItemPeriod absence={preference} />

					<p className="card-label card-label-solicitado">
						{t("preferences.requestedOn")}{" "}
						<Moment className="tag-dia" format="D/MM/YYYY">
							{preference.requested}
						</Moment>
					</p>

					<div className="form-group no-form">
						<span className={`estado ${preference.status}`}>
							{preference.status}
						</span>
					</div>

					{preference.answerer && (
						<div className="form-group no-form card-label-gestionado">
							<Avatar
								userId={preference.answerer.id}
								className="avatar-xxs"
								alt={preference.answerer.name}
							/>{" "}
							{preference.answerer.name} {preference.answerer.surname}
						</div>
					)}

					{preference.answer_comments && (
						<span className="preference-answer-comments">
							{preference.answer_comments}
						</span>
					)}
				</div>

				<div className="card-actions bottom-right">
					{getActions(props, preference, t)}
				</div>
			</article>
		</div>
	));

const getActions = (props, preference, t) => {
	return (
		<Dropdown>
			<Dropdown.Toggle variant="action">
				<FiMoreHorizontal />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item
					as="button"
					onClick={() => props.openEditPreferenceModal(preference, true)}
				>
					{t("common.view")}
				</Dropdown.Item>
				{preference.status !== wfStatus.denied &&
					preference.status !== wfStatus.canceled && (
						<Dropdown.Item
							as="button"
							onClick={() => props.handleCancelRequest(preference)}
						>
							{t("preferences.cancelPreference")}
						</Dropdown.Item>
					)}
				{preference.status !== wfStatus.pending && (
					<Dropdown.Item
						as="button"
						onClick={() => props.handleReopenRequest(preference)}
					>
						{t("preferences.reopenPreference")}
					</Dropdown.Item>
				)}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default withTranslation()(ManagedPreferencesList);
